import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=bafdcf92&scoped=true&"
import script from "./quill.vue?vue&type=script&lang=ts&"
export * from "./quill.vue?vue&type=script&lang=ts&"
import style0 from "./quill.vue?vue&type=style&index=0&id=bafdcf92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafdcf92",
  null
  
)

export default component.exports